/*
 * Test instance. 
 * looks at event binding within this.
 * extending off a view. etc.
 * http://www.andersriggelsen.dk/glblendfunc.php
 */

// this works. but is not ideal/practical.
import TweenMax from 'TweenMax';
import PIXI from 'pixi.js/bin/pixi.min.js';
// this is buggy:
// import Pixi from 'pixi.js';

import {aspectRatio} from '../helpers';
import BaseView from './baseView';



import TwoPointGradient from './shaders/twopointgradient';
import DuoTone from './shaders/duotone';
import Convergence from './shaders/convergence';

import CutSlider from './shaders/cutslider';
import Shaker from './shaders/shaker';
import Twist from './shaders/twist';

import CutAndTwist from './shaders/cutandtwist';
import StuckPixels from './shaders/stuckpixels';

import Artifacts from './shaders/artifacts';
import DisplacementFilter from './shaders/customDisplacementFIlter';

class PixiDisplacement extends BaseView {

	constructor(obj) {

		// super(obj);
		obj.skipSuper = true;
		super(obj);
		
		this.counter = 0;
		this.animating = false;
		this.container = null;
		this.bg = null;
		this.img = null;
		this.gradfilter = null;
		this.convergence = null;
		this.twist = null;
		this.currentGrad = 5;

		this.artifacts = null;
		this.artifactsLoaded = [];

		this.cutandtwist = null;
		this.cutslider = null;

		this.gradList = [
			{
				// bluepurple
				// #7accf2
				colorA: { type: '4f', value: [122/255, 204/255, 242/255, 1.0] },
				// #ab72ff
				colorB: { type: '4f', value: [171/255, 114/255, 255/255, 1.0] },
				
				// diagonal tr to bl (x0,y1, x1,y0)
				colorApos: [0.0,1.0],
				colorBpos: [1.0,0.0],

				// duotone colorB
				// #68179a
				colorThreshold: { type: '4f', value: [104/255, 23/255, 154/255, 1.0] }
			},{
				// purpleblue
				// #a075e2
				colorA: { type: '4f', value: [160/255, 117/255, 226/255, 1.0] },
				// #6269c4
				colorB: { type: '4f', value: [98/255, 105/255, 196/255, 1.0] },

				// diagonal tr to bl (x1,y1, x0,y0)
				colorApos: [0.0,0.0],
				colorBpos: [0.5,1.0],

				// duotone colorB
				// #51178a
				colorThreshold: { type: '4f', value: [81/255, 23/255, 138/255, 1.0] }

			},{
				// orangered
				// #fdc76a
				colorA: { type: '4f', value: [253/255, 199/255, 106/255, 1.0] },
				// #e92751
				colorB: { type: '4f', value: [233/255, 39/255, 81/255, 1.0] },

				// up to down (x.5,y0, x.5,y1)
				colorApos: [0.5,0.0],
				colorBpos: [0.5,1.0],

				// duotone colorB
				// #630c7f
				colorThreshold: { type: '4f', value: [99/255, 12/255, 127/255, 1.0] }
			},{
				// redpurple
				// #ff4167
				colorA: { type: '4f', value: [255/255, 65/255, 103/255, 1.0] },
				// #9c58ff
				colorB: { type: '4f', value: [156/255, 88/255, 255/255, 1.0] },

				// left to right
				colorApos: [0.0,0.0],
				colorBpos: [1.0,0.0],

				// duotone colorB
				// #68179a
				colorThreshold: { type: '4f', value: [104/255, 23/255, 154/255, 1.0] }
			},{
				// aqua select
				// #9bf0e1
				colorA: { type: '4f', value: [155/255, 240/255, 225/255, 1.0] },
				// #9bf0e1
				colorB: { type: '4f', value: [155/255, 240/255, 225/255, 1.0] },

				// left to right
				colorApos: [1.0,0.9],
				colorBpos: [0.2,0.4],

				// duotone colorB
				// #68179a
				colorThreshold: { type: '4f', value: [104/255, 23/255, 154/255, 1.0] }
			},{
				// aqua select
				// #7C26F8
				colorA: { type: '4f', value: [124/255, 34/255, 248/255, 1.0] },
				// #7C26F8
				colorB: { type: '4f', value: [100/255, 20/255, 230/255, 1.0] },

				// left to right
				colorApos: [1.0,0.9],
				colorBpos: [0.2,0.4],

				// duotone colorB
				// #9bf0e1
				colorThreshold: { type: '4f', value: [80/255, 5/255, 100/255, 1.0] }
			}
		];



		this.parent = document.querySelector('.content');
		trace(' ---- pixi ---- ');
		this._offset = 0.32;
		this.maxScale = obj.maxScale || 10;
		this.offsetIncrement = obj.offsetIncrement || 0.1;
		this.currentoffset = this._offset;

		this.imgtoload = "imgs/bjork.png";

		this.artifactList = [
			"imgs/patterns/camo-pattern.gif",
			"imgs/patterns/unicodes.png",
			"imgs/patterns/patterna.png",
			"imgs/patterns/patterns_01.png",
			"imgs/patterns/patterns_03.png",
			"imgs/patterns/patterns_09.png"
		]

		this.loadImg();

		this.mouseDown = false;
				
	}

	bindEvents() {
		this.el.addEventListener('click', this.onClick.bind(this) );
		this.el.addEventListener('touchend', this.onClick.bind(this) );
	}

	onClick(e) {
		var next = this.currentGrad+1;
		if( next >= this.gradList.length ){
			next = 0;
		}

		this.changeDuotones(next);
	}

	loadImg() {
		var _this = this;

		var imageLoader = new PIXI.loaders.Loader(); 
		imageLoader.add(this.imgtoload);
		// imageLoader.once("complete", onComplete.bind(this));
		imageLoader.load(function(loader, resources) {

			// PIXI.utils.TextureCache[]
			// this.renderPixi(new PIXI.Texture(resources.niki.texture));
			
			// this.loadArtifacts();
				
			this.renderPixi();

		}.bind(this));
	}


	loadArtifacts() {
		// loop through and load all!
		var imageLoader = new PIXI.loaders.Loader(); 
		for( var i = 0; i < this.artifactList.length; i++){
			var img = {name:'artifact-'+i, url:this.artifactList[i]};
			imageLoader.add(img);
		}

		imageLoader.once("complete", function(loader, resources) {
			trace(' complete!');
			this.artifactsLoaded = resources;

			trace( this.artifactsLoaded );
			
			this.renderPixi();

		}.bind(this) );

		imageLoader.load();
		

	}

	renderPixi() {
		if( !this.availH && !this.availW ){
			this.draw();
		}
		trace(' render ------- ' + this.availW + ' x ' + this.availH );
		window.PIXI = PIXI;

		this.renderer = PIXI.autoDetectRenderer(this.availW, this.availH, {'transparent':true} );
		

        this.parent.appendChild(this.renderer.view);

        // Stage
        this.stage = new PIXI.Stage(0xFF0000, true);

		// Container
        var container = new PIXI.Container();
        var imgcontainer = new PIXI.Container();

        this.stage.addChild(container);
        
        this.stage.addChild(imgcontainer);

        this.stage.interactive = true;
		
		imgcontainer.width = this.availW;
		imgcontainer.height = this.availW;

		imgcontainer.anchor = new PIXI.Point(0.5,0.5);
		
		imgcontainer.filterArea = new PIXI.Rectangle(0,0, this.availW, this.availH);

        
        // var bg = PIXI.Sprite.fromImage('imgs/nicki.jpg');
        var bg = new PIXI.Sprite(texture);
        
        bg.position.x = this.availW*0.5;
        bg.position.y = this.availH*0.5;
        bg.anchor = new PIXI.Point(0.5, 0.5);
        bg.width = this.availW;
        bg.height = this.availH;

		this.gradfilter = new TwoPointGradient();
        
        
        var texture = new PIXI.Texture(PIXI.utils.TextureCache[this.imgtoload]);
        this.img = new PIXI.Sprite(texture);
        // this.imgclone = new PIXI.Sprite(texture);

        this.img.position.x = this.availW*0.5;
        this.img.position.y = this.availH*0.5;
        
        var ratio = this.availH / texture.height;

        this.img.height = this.availH;
        this.img.width = ratio * texture.width;
        
        this.img.anchor = new PIXI.Point(0.5, 0.5);
		
        this.convergence = new Convergence();
        this.cutslider = new CutSlider();
		this.duotone = new DuoTone();
		this.shaker = new Shaker();
		this.twist = new Twist();
		this.cutandtwist = new CutAndTwist();
		this.stuckPixels = new StuckPixels();

		// this.artifacts = new Artifacts();

        
        
        // this.img.alpha = 0.95;
        // this.img.BLEND_MODES = PIXI.blendModes.COLOR_DODGE;
        // bg.blendMode = PIXI.blendModes.COLOR_DODGE;

        container.addChild(bg);
		container.addChild(this.img);

		// imgcontainer.addChild(this.imgclone);


		window.img = this.img;
        this.container = container;
		this.bg = bg;
		this.el = this.renderer.view;
		this.renderer.render(this.stage);
		window.renderer = this.renderer;
		

		this.generateArtifacts();


		// Apply it
        bg.filters = [
        	this.gradfilter,
        	this.stuckPixels,
        	this.displacementFilter
        ];
		
		this.img.filters = [
			this.duotone
		];  
		
		container.filters = [
			this.displacementFilterImg
		]

		/*this.imgclone.filters = [
			this.duotone
		]; */       

		/*container.filters = [
			// this.shaker,
			// this.cutslider,
			// this.twist
			this.cutandtwist
			// this.displacementFilter
			// this.artifacts
		];*/

		// container.filters = [this.twist];

		// container.filters = [
		// 	this.twist
		// ];

			
		var gl = this.renderer.gl;
		// Transparency is best implemented using blend function (GL_SRC_ALPHA, GL_ONE_MINUS_SRC_ALPHA) 
		// with primitives sorted from farthest to nearest
		// gl.blendFunc(gl.ONE, gl.ZERO);
		
		// gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
		// gl.blendEquation(gl.FUNC_ADD);

		
		this.changeDuotones(this.currentGrad);
		
		this.checkForText();

		this.bindEvents();
	}

	checkForText() {
		var paramsstr = window.location.search.split('?');
		var paramsObj = {};
		if( paramsstr.length > 1 ){
			var params = paramsstr[1].split('&');
			for( var p = 0; p < params.length; p++){
				var pm = params[p].split('=');
				if( pm.length > 1 ){
					params[p] = {type: pm[0], val: pm[1] }
					paramsObj[pm[0]] = decodeURI(pm[1]); 
				}
			}
		}

		if( paramsObj.title ){
			// http://localhost:8081/?title=just%20a%20test%20example%20title
			var ptext = paramsObj.title;
			var text = new PIXI.Text(ptext, {font:"50px Arial", fill:"white"});
			
			text.filters = [
				this.cutandtwist
			];

			text.x = 40;
			text.y = 40;
			this.stage.addChild(text);
		}
	}

	generateArtifacts() {
		trace(' generate artifacts ' );
		trace( this.artifactsLoaded );

		// this.displacementSprite = PIXI.Sprite.fromImage("imgs/displacement_map.png");
		// this.displacementSprite = PIXI.Sprite.fromImage("imgs/noise/grungy_texture_stock_by_amkitsune-d6bbx65.png");
		// this.displacementSprite = PIXI.Sprite.fromImage("imgs/noise/image6.jpg");
		// this.displacementSprite = PIXI.Sprite.fromImage("imgs/patterns/camo2.png");
		this.displacementSprite = PIXI.Sprite.fromImage("imgs/patterns/camo7.gif");
		// this.displacementSprite = PIXI.Sprite.fromImage("imgs/patterns/tv.png");
		// this.displacementSprite = PIXI.Sprite.fromImage("imgs/patterns/camocombo.png");
		//this.displacementSprite = PIXI.Sprite.fromImage("imgs/patterns/characters.png");
		// this.displacementSprite = PIXI.Sprite.fromImage("imgs/patterns/tiles.png", this.availW, this.availH);
		
		this.displacementSprite = PIXI.Sprite.fromImage("imgs/patterns/garbage.png");
		this.displacementSprite.width = this.availW;
		this.displacementSprite.height = this.availH;

		trace( this.availW );

		// this.displacementFilter = new PIXI.filters.DisplacementFilter(this.displacementSprite);
		this.displacementFilter = new DisplacementFilter(this.displacementSprite);


		var dsprite = PIXI.Sprite.fromImage("imgs/patterns/tv.png");

		this.displacementFilterImg = new DisplacementFilter(dsprite);
		this.displacementFilterImg.scale.x = 10;
		this.displacementFilterImg.scale.y = 10;

		// this.displacementFilter.maskBox = [0.4, 0.01, 0.99, 0.6]
		// this.displacementFilter.maskBox = [-1.0, -1.0, 0.0, 0.0]
		// this.container.addChild(this.displacementSprite);

	}

	changeDuotones(next) {
		if( this.duotone == null ){
			trace(' duotone undefined skip');
		}
		this.stuckPixels.numberOfPixels = 7;

		// this.img.alpha = 0.0;
		
		this.animating = true;

		var changer = {
			alpha : 0.0,
			colorAr : this.duotone.u_colorA[0], 
			colorAg : this.duotone.u_colorA[1],
			colorAb : this.duotone.u_colorA[2],
			colorBr : this.duotone.u_colorB[0],
			colorBg : this.duotone.u_colorB[1],
			colorBb : this.duotone.u_colorB[2],

			colorTr : this.duotone.u_colorT[0],
			colorTg : this.duotone.u_colorT[1],
			colorTb : this.duotone.u_colorT[2], 
			
			colorAposx : this.duotone.u_colorApos[0],
			colorAposy : this.duotone.u_colorApos[1],

			colorBposx : this.duotone.u_colorBpos[0],
			colorBposy : this.duotone.u_colorBpos[1],

			cutup	: 20,
			cval1 	: 6,
			cval2 	: 10,
			twvrand : 0.5,
			twv1 : 20.0,
			twv2 : 10.0,
			displaceY : 100,
			displaceX : 10
		}

		var foreground = {
			alpha: 0.0,
			displaceXi : 500,
			displaceYi : 30
		}

		this.cutandtwist.rand = Math.random() * 10.15;
		this.cutandtwist.cutval1 = (Math.random() * 10);
		this.cutandtwist.cutval2 = Math.random() * 30;

		this.cutandtwist.twistrand = Math.random() * 0.1;
		this.cutandtwist.twistval1 = Math.random() * 4.5;
		this.cutandtwist.twistval2 = Math.random() * 4.5;

		this.currentGrad = next;
		
		var _this = this;
		var time = 1.75;

		TweenMax.to(foreground, time * 0.5, {

			displaceXi : 0,
			displaceYi : 0,
			alpha : 1.0,

			ease : Quad.easeOut,

			onUpdate : function() {
				_this.img.alpha = foreground.alpha;

				var inverse = 1;
				if( Math.random() > 0.5 ){
					inverse = -1;
				}

				_this.displacementFilterImg.scale.x = foreground.displaceXi * Math.random() * inverse;
				_this.displacementFilterImg.scale.y = foreground.displaceYi * Math.random() * inverse;
							
			}
		});


		TweenMax.to(changer, time, {
			colorAr : this.gradList[next].colorA.value[0], 
			colorAg : this.gradList[next].colorA.value[1],
			colorAb : this.gradList[next].colorA.value[2],
			colorBr : this.gradList[next].colorB.value[0],
			colorBg : this.gradList[next].colorB.value[1],
			colorBb : this.gradList[next].colorB.value[2],

			colorTr : this.gradList[next].colorThreshold.value[0],
			colorTg : this.gradList[next].colorThreshold.value[1],
			colorTb : this.gradList[next].colorThreshold.value[2],

			colorAposx : this.gradList[next].colorApos[0],
			colorAposy : this.gradList[next].colorApos[1],
			
			colorBposx : this.gradList[next].colorBpos[0],
			colorBposy : this.gradList[next].colorBpos[1],


			alpha : 1.0,

			cutup : 0,
			cval1 : 0,
			cval2 : 2,

			twvrand : 0.0,
			twv1 : 0.0,
			twv2 : 0.0,

			displaceY : 200,
			displaceX : 0,

			displaceXi : 0,
			displaceYi : 0,

			ease : Quad.easeOut,

			onUpdate : function() {
				_this.duotone.u_colorA = [changer.colorAr,changer.colorAg,changer.colorAb,1.0];
				
				_this.duotone.u_colorB = [changer.colorBr,changer.colorBg,changer.colorBb,1.0];
				_this.duotone.u_colorT = [changer.colorTr,changer.colorTg,changer.colorTb,1.0];

				_this.duotone.u_colorApos = [changer.colorAposx,changer.colorAposy];
				_this.duotone.u_colorBpos = [changer.colorBposx,changer.colorBposy];
				

				_this.gradfilter.u_colorA = [changer.colorAr,changer.colorAg,changer.colorAb,1.0];
				_this.gradfilter.u_colorB = [changer.colorBr,changer.colorBg,changer.colorBb,1.0];

				_this.gradfilter.u_colorA = [changer.colorAr,changer.colorAg,changer.colorAb,1.0];
				_this.gradfilter.u_colorB = [changer.colorBr,changer.colorBg,changer.colorBb,1.0];

				_this.gradfilter.u_colorApos = [changer.colorAposx,changer.colorAposy];
				_this.gradfilter.u_colorBpos = [changer.colorBposx,changer.colorBposy];

				// _this.img.alpha = changer.alpha;

				_this.cutandtwist.rand = Math.random() * changer.cutup;
				_this.cutandtwist.cutval1 = changer.cval1;
				_this.cutandtwist.cutval2 = changer.cval2;
				_this.cutandtwist.twistrand = Math.random() * changer.twvrand;
				_this.cutandtwist.twistval1 = Math.random() * changer.twv2;
				_this.cutandtwist.twistval2 = Math.random() * changer.twv2;


				_this.displacementFilter.scale.x = changer.displaceX;
				_this.displacementFilter.scale.y = changer.displaceY * Math.random();
				
				_this.stuckPixels.numberOfPixels = 10;

				_this.renderer.render(_this.stage);

			},
			onComplete : function() {
				// _this.stuckPixels.numberOfPixels = 0;

				// _this.img.alpha = 0;
				// _this.imgclone.alpha = 1;
				_this.animating = false;
				
				// _this.displacementFilter.scale.x = 0;
				// _this.displacementFilter.scale.y = 0;

				// _this.cutandtwist.rand = 0;
				// _this.cutandtwist.cutval1 = 0;
				// _this.cutandtwist.cutval2 = 0;

				_this.renderer.render(_this.stage);

			}
		})
	}


	animationFrame() {
		if( !this.el || !this.animating ){
			return;
		}

		
		
		// this.cutandtwist.timer = Math.random() * 10;
		// this.cutandtwist.horizontal = Math.random();

		this.convergence.rand = (Math.random() * 5.0 );
		// this.convergence.dimensions = [Math.random(), Math.random(), 0.0, 0.0];

		// this.cutslider.rand = -5; //Math.random() * 1;
		// this.cutslider.val1 = 1; //Math.random() * 200;
		// this.cutslider.val2 = 1.5; //Math.random() * 50;
		
		// this.cutslider.rand = Math.random() * 1;
		// this.cutslider.val1 = Math.random() * 200;
		// this.cutslider.val2 = Math.random() * 50;
		
		// this.cutslider.horizontal = 1.0 ;//Math.random();

		// trace( this.shaker.blurX );

		/*var ran = Math.random();
		if( ran > 0.5 ){
			this.shaker.blurX = Math.random() * 5.0;
			this.shaker.blurY = 0;
		}else{
			this.shaker.blurX = 0;
			this.shaker.blurY = Math.random() * 5.0;
		}*/

		return;

		// this.twist.rand = Math.random() * 5.05;
		// this.twist.rand = Math.random() * 5.5;
		// this.twist.timer = Math.random() * 2;
		// this.twist.val2 = Math.random() * 20;
		// this.twist.val3 = Math.random() * 20;
		// this.twist.horizontal = 0.0;


		this.renderer.render(this.stage);
	}

	// on resize.
	draw(obj) {

		if(obj == null ){ }

		var w = this.parent.clientWidth,
			h = this.parent.clientHeight;

		this.availW = w;
		this.availH = h;

		this.animationFrame()
	}
}


module.exports = PixiDisplacement;


/** WEBPACK FOOTER **
 ** ./src/js/views/twitch.js
 **/